import React from "react";
import PropTypes from "prop-types";

import "apps/messenger/components/MainWindow/MessagePane/ActionPrompt.scss";

const ActionPrompt = ({
	text, children,
}) => (
	<div className="messenger-action-prompt">
		{text}
		{children && (
			<div className="messenger-action-prompt-actions">
				{children}
			</div>
		)}
	</div>
);

ActionPrompt.propTypes = {
	text: PropTypes.string,
	children: PropTypes.any,
};

ActionPrompt.defaultProps = {
	text: "",
	children: null,
};

export default ActionPrompt;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/MessagePane/ActionPrompt.jsx